module.exports = __webpack_public_path__ + "img/lb.cab12aa9.svg";